import script from "./FounderWelcomeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FounderWelcomeModal.vue?vue&type=script&setup=true&lang=js"

import "./FounderWelcomeModal.vue?vue&type=style&index=0&id=257f657c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-257f657c"]])

export default __exports__